import parse from 'html-react-parser'
import Head from 'next/head'

import { FRONT_BASE_URL } from '@/constants'

import { WPPageData } from '@/types'

type MetaProps = {
  pageData: WPPageData
}

const Meta = ({ pageData }: MetaProps) => {
  const robotsContent = [
    pageData?.meta_robots?.is_robots_noindex ? 'noindex' : 'index',
    pageData?.meta_robots?.is_robots_nofollow ? 'nofollow' : 'follow'
  ]
    .filter(Boolean)
    .join(', ')

  return (
    <Head>
      {parse(
        pageData?.yoast_head?.replace(/"\//g, `"${FRONT_BASE_URL}/`) || ''
      )}
      {robotsContent ? <meta name="robots" content={robotsContent} /> : null}
    </Head>
  )
}

export default Meta
